<div class="school-card card">
  @if (school.Address) {
    <button type="button" class="address" [matMenuTriggerFor]="addressMenu">
      <i class="icon-location-filled icon-text-blue"></i>
      <div class="address-lines text-header-blue">
        <div class="street-address">{{school.Address}}</div>
        <div class="city-state-zip">{{school.City}}, {{school.StateCode}} {{school.ZipCode}}</div>
      </div>
    </button>
    <mat-menu #addressMenu="matMenu">
      <button type="button" mat-menu-item (click)="openSchoolInGoogleMaps()" rtI18n>Open in Google Maps</button>
      <button type="button" mat-menu-item (click)="copySchoolAddress()" rtI18n>Copy Address</button>
    </mat-menu>
  }

  <!-- Special attendance email for PVA -->
  @if (school.Id === 1970) {
    <button type="button" class="phone" [matMenuTriggerFor]="attendanceEmailMenu">
      <i class="icon-mail icon-text-blue"></i>
      <div class="attendance-email-text">
        <span class="text-action-blue"><b>pvaattendance@nhaschools.com </b></span>
        <span class="subtext">Attendance questions & absences</span>
      </div>
    </button>
    <mat-menu #attendanceEmailMenu="matMenu">
      <a mat-menu-item href="mailto:pvaattendance@nhaschools.com" rtI18n>Send Email</a>
      <button type="button" mat-menu-item (click)="copyAttendanceEmail()" rtI18n>Copy Email</button>
    </mat-menu>
  }

  @if (school.Phone) {
    <button type="button" class="phone" [matMenuTriggerFor]="phoneMenu">
      <i class="icon-phone icon-text-blue"></i>
      <span class="text-action-blue"><b>{{formatSchoolPhone()}}</b></span>
    </button>
    <mat-menu #phoneMenu="matMenu">
      <a mat-menu-item [href]="'tel:' + getSchoolPhoneDigits()" rtI18n>Call</a>
      <button type="button" mat-menu-item (click)="copySchoolPhone()" rtI18n>Copy Phone Number</button>
    </mat-menu>
  }

  @if (websiteUrl) {
    <a class="website" [href]="websiteUrl" target="_blank" rel="noopener noreferrer">
      <i class="icon-globe icon-text-blue"></i>
      <span class="text-action-blue"><b rtI18n>School Website</b></span>
      <i class="icon-open-new-page icon-action-blue"></i>
    </a>
  }
  @if (lunchMenuUrl) {
    <a class="lunch-menu" [href]="lunchMenuUrl" target="_blank" rel="noopener noreferrer">
      <i class="icon-fork-spoon icon-action-blue"></i>
      <span rtI18n>Lunch Menu</span>
      <i class="icon-open-new-page icon-action-blue"></i>
    </a>
  }
  @if (canAccessDirectory || canAccessCalendar) {
    <div class="school-app-links">
      @if (canAccessDirectory) {
        <button type="button" class="school-app-link" (click)="openAppForSchool('directory')">
          <i class="icon-user-groups icon-action-blue"></i>
          <span rtI18n>Directory</span>
        </button>
      }
      @if (canAccessCalendar) {
        <button type="button" class="school-app-link" (click)="openAppForSchool('calendar')">
          <i class="icon-calendar icon-action-blue"></i>
          <span rtI18n>Calendar</span>
        </button>
      }
      <button type="button" class="school-app-link" (click)="openResources()">
        <i class="icon-paper-clip icon-action-blue"></i>
        <span rtI18n>Resources</span>
      </button>
      <!-- TODO: Parent Portal - flesh out the school card content -->
      <!-- TODO Document Upload for admins of school/ -->
      <!-- Volunteering is a guardian activity — staff and students never see the form link. -->
      @if (isGuardian) {
        @if (volunteerStatus?.Error) {
          <div class="school-app-link volunteer-needs-attention">
            <i class="icon-volunteer icon-text-blue"></i>
            <span rtI18n>Volunteer</span>
            <i class="icon-info-filled icon-red trailing-icon"></i>
          </div>
          <div class="volunteer-error-banner">
            <i class="icon-info-filled icon-red"></i>
            <div class="banner-text">
              <span rtI18n>There's an issue with your volunteer application. Please call Parent Relations at</span>&ngsp;<button type="button" class="phone-link" [matMenuTriggerFor]="parentRelationsMenu">{{parentRelationsPhoneDisplay}}</button><span>.</span>
              <mat-menu #parentRelationsMenu="matMenu">
                <a mat-menu-item [href]="parentRelationsPhoneTel" rtI18n>Call</a>
                <button type="button" mat-menu-item (click)="copyParentRelationsPhone()" rtI18n>Copy Phone Number</button>
              </mat-menu>
            </div>
          </div>
        } @else {
          <a class="school-app-link" [href]="volunteerFormUrl" target="_blank" rel="noopener noreferrer"
             (click)="portalLink.interceptAnchorClick($event, volunteerFormUrl)">
            <i class="icon-volunteer icon-action-blue"></i>
            <span rtI18n>Volunteer</span>
            @if (volunteerStatus?.Exists) {
              <i class="icon-circle-check icon-green trailing-icon"></i>
            } @else {
              <i class="icon-open-new-page icon-action-blue"></i>
            }
          </a>
        }
      }

    </div>
  }
</div>
